import axios from "axios";

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL ?? "https://admin.cargooapp.com/api",
    headers: { "Content-Type": "application/json" },
});
